import { Pipe, PipeTransform } from '@angular/core'
import { PCFHoldingEntity } from 'src/app/models/portfolio-models/pcf-basket-response.model'
import {
  HoldingEntity,
  MoneyMarketHoldingEntity,
} from 'src/app/models/portfolio-models/portfolio-holding-response.model'

@Pipe({
  name: 'portfolioHoldingsSort',
})
export class PortfolioHoldingsSortPipe implements PipeTransform {
  // eslint-disable-next-line complexity
  transform(
    value: HoldingEntity[] | MoneyMarketHoldingEntity[] | PCFHoldingEntity[],
    column: string,
    direction: string,
  ): HoldingEntity[] | MoneyMarketHoldingEntity[] | PCFHoldingEntity[] {
    if (value === undefined || value === null) {
      return []
    }
 
    switch (column) {
      case 'holdingsName':
        value = this.performAlphabeticalSort(value, direction)
        break
        case 'marketValue':
        value = this.performMarketValueSort(value, direction)
        break
      case 'principalAmount':
        value = this.performPrincipalAmountSort(value, direction)
        break
      case 'sharesHeld':
        value = this.performSharesHeldSort(value, direction)
        break
    }
    
    return value
  }

  performAlphabeticalSort(value: any, direction: string): any {
    const sortedvalue = value.sort((a, b) =>
      a.longName
        .replace('Vanguard ', '')
        .localeCompare(b.longName.replace('Vanguard ', '')),
    )
    if (direction === 'desc') {
      return sortedvalue.reverse()
    }
    return sortedvalue
  }

  performMarketValueSort(value: any, direction: string): any {
    if (direction === 'desc') {
      return value.sort((a, b) => a.marketValue - b.marketValue).reverse()
    }

    return value.sort((a, b) => a.marketValue - b.marketValue)
  }
  
  performPrincipalAmountSort(value: any, direction: string): any {
    if (direction === 'desc') {
      return value
        .sort((a, b) => a.principalAmount - b.principalAmount)
        .reverse()
    }

    return value.sort((a, b) => a.principalAmount - b.principalAmount)
  }

  performSharesHeldSort(value: any, direction: string): any {
    if (direction === 'desc') {
      return value.sort((a, b) => a.shareQuantity - b.shareQuantity).reverse()
    }

    return value.sort((a, b) => a.shareQuantity - b.shareQuantity)
  }
}
